import React from "react";
import { useTranslation } from "react-i18next";

const DeliveryPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="affiliate">
        <div className="container  trems-and-condition">
          <div className="row pt-md-5 justify-content-center pb-md-5 pb-4">
            <div className="col-10 px-4">
              <div className="refund-eligibility">
              <h3 className="py-md-4 py-3 tc-head fw-bold">{t('dph1')}</h3>
                <p  className="tc-text mt-md-1 mb-md-3 my-2">
                {t('dpp1')}
                </p>
                <h5 className="tc-title fw-bold">{t('dph2')}</h5>
                    <p className="tc-text my-md-4 my-2">
                    {t('dpp2')}
                    </p>

                  <h5 className="tc-title fw-bold"> {t('dph3')}</h5>
                    <ul className="py-1 ps-3 ps-md-3 ms-0 ms-md-3 mb-md-1">
                      <li  className="py-2 tc-text">
                      {t('dpp3')}
                      </li>
                      <li  className="py-2 tc-text">
                      {t('dpp4')}
                      </li>
                    </ul>

                  <h5 className="tc-title fw-bold">{t('dph4')}</h5>
                    <ul className="py-1 ps-3 ps-md-3 ms-0 ms-md-3 mb-md-1">
                      <li  className="py-2 tc-text">
                      {t('dpp5')}
                      </li>
                      <li  className="py-2 tc-text">
                      {t('dpp6')}
                      </li>
                    </ul>

                  <h5 className="tc-title fw-bold">{t('dph5')}</h5>
                    <ul className="py-1 ps-3 ps-md-3 ms-0 ms-md-3 mb-md-1">
                      <li  className="py-2 tc-text">
                      {t('dpp7')}
                      </li>
                      <li  className="py-2 tc-text">
                      {t('dpp8')}
                      </li>
                    </ul>

                  <h5 className="tc-title fw-bold">{t('dph6')}</h5>
                    <p  className="tc-text mt-md-1 mb-md-3 my-2">
                    {t('dpp9')}
                    </p>
                    <ul className="py-1 ps-3 ps-md-3 ms-0 ms-md-3 mb-md-1">
                      <li  className="py-2 tc-text">
                      {t('dpp10')}
                      </li>
                      <li  className="py-2 tc-text">
                      {t('dpp11')}
                      </li>
                      <li  className="py-2 tc-text">
                      {t('dpp12')}
                      </li>
                    </ul>

                  <h5 className="tc-title fw-bold"> {t('dph7')}</h5>
                    <p  className="tc-text mt-md-1 mb-md-3 my-2">
                    {t('dpp13')}
                    </p>
                  <h5 className="tc-title fw-bold">{t('dph8')}</h5>
                    <p  className="tc-text mt-md-1 mb-md-3 my-2">
                    {t('dpp14')}
                    </p>

                  <h5 className="tc-title fw-bold">{t('dph9')}</h5>
                    <p  className="tc-text mt-md-1 mb-md-3 my-2">
                    {t('dpp15')}
                    </p>

                  <h5 className="tc-title fw-bold">{t('dph10')}</h5>
                    <p  className="tc-text mt-md-1 mb-md-3 my-2">
                    {t('dpp16')}
                    </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeliveryPolicy;
